<span class="column__content" (click)="nextStatus()">
  <ng-content></ng-content>
  <span class="column__arrow--all" *ngIf="status === 0">
    <img class="column__arrow--up-down" src="../../../../assets/svgs/icon_order_up.svg" alt="Ordenar crescente"/>
    <img class="column__arrow--up-down" src="../../../../assets/svgs/icon_order_down.svg" alt="Ordenar descrescente"/>
  </span>
  <span class="column__arrows" *ngIf="status !== 0">
    <img class="column__arrow--up-down" *ngIf="status == 1" src="../../../../assets/svgs/icon_order_down.svg" alt="Ordenar descrescente"/>
    <img class="column__arrow--up-down" *ngIf="status == 2"src="../../../../assets/svgs/icon_order_up.svg" alt="Ordenar crescente"/>
  </span>
</span>